import React, { useEffect, useRef, useState } from "react";
import { BeatLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "@windmill/react-ui";
import { CreateCtiCredential, DeleteReduxDataCreateTicket, DeleteReduxDataDeleteCti, GetAllCtiCredential } from "../../api/Actions/ServiceCTI";
import { DeleteCtiCredential, GetCtiTicketField, UpdateCtiCredential } from "../../api/Actions/ServiceCTI/ServiceCti";
import { DeleteReduxDataCreateCti, DeleteReduxDataUpdateCti } from "../../api/Actions/ServiceCTI/";
import TestTicketModal from "./TestTicketModal";
import CtiModal from "./CtiModal";
import { DeleteReduxDataAllCtiCredential } from "../../api/Actions/ServiceCTI/DeleteReduxDataCti";

export default function Configuration() {
  const [Domain, setDomain] = useState("");
  const [ApiKey, setApiKey] = useState("");
  const [Email, setEmail] = useState("");
  const [OpenModal, setOpenModal] = useState(false);
  const [DisableButton, setDisableButton] = useState(true);
  const [DisableRemoveButton, setDisableRemoveButton] = useState(false);
  const [DisableTestButton, setDisableTestButton] = useState(true);
  const [Loading, setLoading] = useState(true);
  const [ErrorEmail, setErrorEmail] = useState(false);
  const [ErrorDomain, setErrorDomain] = useState(false);

  const dispatch = useDispatch();
  const ctiType = useSelector((state) => state.ReduxState.ctiType);
  // use ref to handle new mount behavior
  let doGetdata = useRef(true);
  // create cti data redux
  const createCredential = useSelector((state) => state.CtiCredential.CreateCtiCredential);
  const errorCreateCredential = useSelector((state) => state.CtiCredential.errorCreateCtiCredential);
  // get all cti data redux
  const AllCtiCredential = useSelector((state) => state.CtiCredential.GetAllCtiCredential);
  // update cti data redux
  const PutCtiCredential = useSelector((state) => state.CtiCredential.PutCtiCredential);
  const errorPutCtiCredential = useSelector((state) => state.CtiCredential.errorPutCtiCredential);
  // delete cti data redux
  const DeleteCtiData = useSelector((state) => state.CtiCredential.DeleteCtiCredential);
  const errorDeleteCtiCredential = useSelector((state) => state.CtiCredential.errorDeleteCtiCredential);
  // ticket field modal open status
  const TicketFieldModal = useSelector((state) => state.ReduxState.TicketFieldModal);
  // ticket field modal open status
  const TicketTestModal = useSelector((state) => state.ReduxState.TestTicketModal);
  const LoadingTicketField = useSelector((state) => state.ReduxState.LoadingTicketField);

  //  HANDLE BUTTON
  const handleGetTicketField = () => {
    //  getting ticket field
    dispatch({ type: "set", TicketFieldModal: !TicketFieldModal });
    const param = {
      orgUuid: localStorage.getItem("orgUuid"),
    };
    dispatch(GetCtiTicketField(ctiType, param));
    dispatch({ type: "set", LoadingTicketField: true });
  };

  const handleTestTicketField = () => {
    // test ticket fields
    dispatch(DeleteReduxDataCreateTicket());
    dispatch({ type: "set", TestTicketModal: !TicketTestModal });
  };

  const handleRemoveIntegration = () => {
    // remove the integration
    setLoading(true);
    setOpenModal(false);
    const ctiId = AllCtiCredential.rows[0].id;

    dispatch(DeleteCtiCredential(ctiType, ctiId));

    const orgUuid = localStorage.getItem("orgUuid");
    const param = {
      query: `$ctiCredential.orgUuid$:${orgUuid}`,
    };
    dispatch(GetAllCtiCredential(param, ctiType));
  };

  const handleSaveConfiguration = () => {
    //  save integration configuration
    setLoading(true);
    setDisableButton(true);

    dispatch(DeleteReduxDataCreateCti());
    dispatch(DeleteReduxDataUpdateCti());
    dispatch(DeleteReduxDataDeleteCti());
    setTimeout(() => {
      if (AllCtiCredential && AllCtiCredential.count > 0) {
        const reqData = {
          domain: Domain,
          apiKey: ApiKey,
          email: Email,
          statusId: 1,
        };

        const ctiId = AllCtiCredential.rows[0].id;
        dispatch(UpdateCtiCredential(reqData, ctiType, ctiId));
      } else {
        const reqData = {
          domain: Domain,
          apiKey: ApiKey,
          orgUuid: localStorage.getItem("orgUuid"),
          email: Email,
        };
        dispatch(CreateCtiCredential(reqData, ctiType));
      }
    }, 1000);
  };

  useEffect(() => {
    console.log(ctiType, "CTI_TYPE");
    setLoading(true);
    // if (doGetdata.current) {
    console.log("MASUK");
    doGetdata.current = false;
    const orgUuid = localStorage.getItem("orgUuid");
    const param = {
      query: `$ctiCredential.orgUuid$:${orgUuid}`,
    };

    setDomain("");
    setApiKey("");
    setEmail("");
    dispatch(GetAllCtiCredential(param, ctiType));
    // }
  }, [ctiType]);

  useEffect(() => {
    // all cti credential
    if (AllCtiCredential && AllCtiCredential.count > 0) {
      // console.log("all");
      const data = AllCtiCredential.rows[0];
      setDomain(data.metadata.domain);
      setApiKey(data.metadata.apiKey);
      setEmail(data.metadata.email);
      setDisableTestButton(true);
    } else {
      // console.log("notall");
      setDisableTestButton(true);
    }
    setLoading(false);
  }, [AllCtiCredential]);

  useEffect(() => {
    setLoading(true);
    dispatch(DeleteReduxDataCreateCti());
    dispatch(DeleteReduxDataUpdateCti());
    dispatch(DeleteReduxDataDeleteCti());
  }, []);

  // HANDLE NOTIFICATION
  const notify = (message, id) => {
    if (id === "success") {
      toast.success(message, {
        id: id,
      });
    } else if (id === "failed") {
      toast.error(message, {
        id: id,
      });
    }
  };

  // create integration
  useEffect(() => {
    //  handle error create integration
    // console.log(createCredential, "CREATE CREDENTIALS");
    if (createCredential) {
      // console.log("MASUK CREATE CREDENTIAL");
      setLoading(false);
      notify(createCredential.message);
      setDisableButton(false);
    }

    const orgUuid = localStorage.getItem("orgUuid");
    const param = {
      query: `$ctiCredential.orgUuid$:${orgUuid}`,
    };
    dispatch(GetAllCtiCredential(param, ctiType));
  }, [createCredential]);

  // update integration
  useEffect(() => {
    if (PutCtiCredential) {
      // console.log("MASUK KE PUT");
      notify(PutCtiCredential.message);
      setDisableButton(false);
    }
    if (errorPutCtiCredential) {
      // console.log("MASUK KE ERROR PUT");
      notify(errorPutCtiCredential);
      setDisableButton(false);
    }
    setLoading(false);
  }, [PutCtiCredential]);

  useEffect(() => {
    // console.log("MASUK ERROR CREATE CREDENTIAL", errorCreateCredential);
    if (errorCreateCredential) {
      setLoading(false);
      notify(errorCreateCredential);
      setDisableButton(false);
    }
  }, [errorCreateCredential]);

  // remove integration
  useEffect(() => {
    setDomain("");
    setApiKey("");
    setEmail("");
    if (DeleteCtiData.success) {
      notify(DeleteCtiData.message);

      setDisableTestButton(true);
      setDisableRemoveButton(false);
      setDisableButton(false);
    } else if (errorDeleteCtiCredential) {
      notify(errorDeleteCtiCredential);
      setDisableRemoveButton(false);
    }

    setLoading(false);
  }, [DeleteCtiData]);

  useEffect(() => {
    // please fill up all credentil input before click save
    if (Domain && ApiKey && Email !== "") {
      if (Email.indexOf(" ") !== -1) {
        setErrorEmail(true);
      } else if (true !== /\S+@\S+\.\S+/.test(Email)) {
        setErrorEmail(true);
      } else {
        setErrorEmail(false);
      }

      switch (ctiType) {
        case "zendesk":
          if (Domain.indexOf("zendesk.com") === -1) {
            setErrorDomain(true);
            setDisableButton(true);
          } else {
            setErrorDomain(false);
            setDisableButton(false);
          }
          break;
        case "freshdesk":
          if (Domain.indexOf("freshdesk.com") === -1) {
            setErrorDomain(true);
            setDisableButton(true);
          } else {
            setErrorDomain(false);
            setDisableButton(false);
          }
          break;
        case "freshsales":
          if (Domain.indexOf("myfreshworks.com") === -1) {
            setErrorDomain(true);
            setDisableButton(true);
          } else {
            setErrorDomain(false);
            setDisableButton(false);
          }
          break;
        default:
          break;
      }

      if (ErrorEmail && ErrorDomain !== true) {
        setDisableButton(false);
      }
      // console.log(ErrorDomain, ErrorEmail, "error email or domain");
    } else {
      setDisableButton(true);
    }
  }, [Domain, ApiKey, Email]);

  return (
    <>
      {Loading ? (
        <div className="flex flex-col mt-4 shadow-inner bg-slate-100 rounded-xl h-full w-full overflow-y-auto">
          <div className="flex flex-col mx-auto my-auto">
            <p className="text-center mb-2">Please wait...</p>
            <BeatLoader className="mx-auto my-auto" color="#075985" size={8} />
          </div>
        </div>
      ) : (
        <div className="flex flex-col mt-4 shadow-inner bg-slate-100 rounded-xl h-full w-full overflow-y-auto">
          <div className="flex flex-col sm:flex-row w-full sm:border-b sm:p-6 border-gray-200 justify-between">
            <div className="flex flex-col sm:flex-row text-xs w-full">
              <button
                disabled={DisableTestButton}
                onClick={(e) => handleGetTicketField()}
                className={
                  (DisableTestButton ? "cursor-not-allowed" : "") +
                  " poppins-500 bg-main-blue text-white py-3 px-4 rounded-md my-2 mx-6 sm:mx-2 active:bg-sky-700 active:bg-blue-300"
                }
              >
                Custom Ticket Field
              </button>
              <button
                disabled={DisableTestButton}
                onClick={(e) => handleTestTicketField()}
                className={
                  (DisableTestButton ? "cursor-not-allowed" : "") +
                  " poppins-500 bg-main-blue text-white py-3 px-4 rounded-md my-2 mx-6 sm:mx-2 active:bg-sky-700"
                }
              >
                Test Create Ticket
              </button>
            </div>

            <div className="flex flex-col sm:flex-row text-xs w-full justify-end pr-8">
              {AllCtiCredential && AllCtiCredential.count > 0 ? (
                <button
                  disabled={DisableRemoveButton}
                  onClick={(e) => {
                    setOpenModal(true);
                    setDisableRemoveButton(true);
                  }}
                  className={
                    (DisableButton ? "text-gray-500" : "") +
                    " poppins-500 bg-red-500 sm:bg-transparent sm:text-black text-white py-3 rounded-md my-2 mx-6 sm:mx-2"
                  }
                >
                  Remove Integration
                </button>
              ) : (
                ""
              )}
              <button
                disabled={DisableButton}
                onClick={(e) => handleSaveConfiguration()}
                className={
                  (DisableButton ? "bg-blue-400" : "bg-main-blue") +
                  " poppins-500 text-white py-3 px-4 rounded-md my-2 mx-6 sm:mx-2 active:bg-sky-700"
                }
              >
                Save
              </button>
            </div>
          </div>
          <div className="flex flex-col w-full h-full p-4 sm:px-20 ">
            <label className="poppins-500 mt-4 text-xs sm:text-base" htmlFor="">
              SUB DOMAIN
            </label>
            <input
              onChange={(e) => {
                setDomain(e.target.value);
              }}
              value={Domain}
              type="text"
              className="rounded-md h-10 border border-gray-200 bg-transparent ring-0 mb-4 p-2 focus:outline-none"
            />

            {ErrorDomain ? <p className="text-red-500">Invalid Domain Format</p> : ""}
            <label className="poppins-500 mt-4 text-xs sm:text-base" htmlFor="">
              API KEY
            </label>
            <input
              value={ApiKey}
              onChange={(e) => {
                setApiKey(e.target.value);
              }}
              type="text"
              className="rounded-md h-10 border border-gray-200 bg-transparent ring-0 mb-4 p-2 focus:outline-none"
            />
            <label className="poppins-500 mt-4 text-xs sm:text-base " htmlFor="">
              ORG UUID
            </label>
            <input
              type="text"
              value={localStorage.getItem("orgUuid")}
              disabled
              className="rounded-md h-10 border border-gray-200 bg-transparent ring-0 mb-4 p-2 focus:outline-none bg-gray-100"
            />
            <label className="poppins-500 mt-4 text-xs sm:text-base" htmlFor="">
              EMAIL ROOT
            </label>
            <input
              value={Email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              type="email"
              className="rounded-md h-10 border border-gray-200 bg-transparent ring-0 p-2 focus:outline-none"
            />
            {ErrorEmail ? <p className="text-red-500">Invalid Email Format</p> : ""}
          </div>
          <div className="w-full h-full p-4 sm:px-20">
            <Toaster
              position="center"
              reverseOrder={false}
              gutter={8}
              containerClassName=""
              containerStyle={{}}
              toastOptions={{
                // Define default options
                className: "",
                duration: 1000,
                style: {
                  background: "#363636",
                  color: "#fff",
                },

                // Default options for specific types
                success: {
                  duration: 3000,
                  theme: {
                    primary: "green",
                    secondary: "black",
                  },
                },
              }}
            />
          </div>
          <Modal
            onClose={(e) => {
              setOpenModal(false);
              setDisableRemoveButton(false);
            }}
            isOpen={OpenModal}
          >
            <ModalHeader>Remove Integration</ModalHeader>
            <ModalBody>Are you sure want to remove the integration ?</ModalBody>
            <ModalFooter>
              <Button
                className="w-full sm:w-auto"
                layout="outline"
                onClick={(e) => {
                  setOpenModal(false);
                  setDisableRemoveButton(false);
                }}
              >
                Cancel
              </Button>
              <Button
                className="w-full sm:w-auto bg-main-blue"
                layout="outline"
                onClick={(e) => {
                  handleRemoveIntegration();
                  setDisableTestButton(true);
                }}
              >
                <p className="text-white">Procced</p>
              </Button>
            </ModalFooter>
          </Modal>
          <CtiModal />
          <TestTicketModal />
        </div>
      )}
    </>
  );
}
